export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8547.55cfb42f.jpg";